export const RESET_PAGINATION = 'RESET_PAGINATION';
export const RESET_FILTERS = 'RESET_FILTERS';
export const FILTER_BY = 'FILTER_BY';
export const SORT_BY = 'SORT_BY';
export const ORDER_BY = 'ORDER_BY';
export const SET_PREVIOUS_PAGE = 'SET_PREVIOUS_PAGE';
export const SET_NEXT_PAGE = 'SET_NEXT_PAGE';
export const SET_DEFAULT_FILTERBY = 'SET_DEFAULT_FILTERBY';
export const SET_DEFAULT_SORTBY = 'SET_DEFAULT_SORTBY';
export const SET_DEFAULT_ORDERBY = 'SET_DEFAULT_ORDERBY';